var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-center",attrs:{"id":"logo"}},[_c('img',{staticClass:"wellful-logo-img mt-3 mb-3 sm:mb-12 sm:mt-12",attrs:{"src":require("@/assets/images/logo.png"),"alt":"Wellful Logo"}})])
}]

export { render, staticRenderFns }